import { useQuery } from 'hooks/useCustomQuery';
import getSBCByID from 'API/SBC/getSBCByID';

const useGetSBC = (sbcId, enabled = true) => {
    return useQuery({
        queryKey: ['SBC', sbcId],
        queryFn: async () => {
            const response = await getSBCByID(sbcId);
            return response.data;
        },
        enabled: enabled && !!sbcId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetSBC;
